import cn from 'classnames';
import { motion } from 'framer-motion';
import React, { useCallback, useContext, useMemo } from 'react';
import { tailwindConfig } from 'tailwind-config';

import { PairWalletsContext } from 'context/PairWalletsContext/PairWalletsContext';
import { useWithdrawalWhitelistStatus } from 'hooks/dex';

import { CogIcon, CogSolidIcon } from 'assets/icons';

const WithdrawWhitelistButton: React.FC = () => {
  const {
    modals: { whitelistWithdrawOpened },
  } = useContext(PairWalletsContext);

  const whitelistStatus = useWithdrawalWhitelistStatus();

  const handleOpenWithdrawalWhitelistModal = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      event.stopPropagation();

      whitelistWithdrawOpened.set(true);
    },
    [whitelistWithdrawOpened],
  );

  const isPending = useMemo(
    () => whitelistStatus?.pendingCount !== undefined && whitelistStatus?.pendingCount !== 0,
    [whitelistStatus],
  );

  return (
    <motion.div
      className={cn(
        'ww-status-button',
        whitelistStatus?.status === 'pending' ? '_pending' : '_success',
      )}
      onClick={handleOpenWithdrawalWhitelistModal}
    >
      {isPending ? (
        <CogSolidIcon color={tailwindConfig.theme.colors['bg-primary']} />
      ) : (
        <CogIcon color={tailwindConfig.theme.colors.primary} />
      )}
      {isPending && <span className="pending-count">{whitelistStatus!.pendingCount}</span>}
    </motion.div>
  );
};

export { WithdrawWhitelistButton };
